<template>
  <GbwapsLayout
    title="GB WhatsApp Not Working - Common Fixes"
    :intro="pageIntro"
    :breadcrumb="breadcrumb"
  >
    <div class="troubleshooting-page">
      <section
        v-for="section in sections"
        :id="section.id"
        :key="section.id"
        class="page-section site-section"
      >
        <h2>{{ section.h2 }}</h2>
        <ContentBlocks :blocks="section.blocks" />
        <div v-if="section.cards && section.cards.length" class="problem-solution-grid">
          <ProblemSolutionCard
            v-for="card in section.cards"
            :key="card.title"
            :icon="card.icon"
            :title="card.title"
            :symptoms="card.symptoms"
            :solutions="card.solutions"
          />
        </div>
      </section>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import ProblemSolutionCard from '@/components/gbwaps/ProblemSolutionCard.vue';
import { TROUBLESHOOTING_SECTIONS } from '@/data/troubleshooting-content';

export default {
  name: 'TroubleshootingPage',
  components: { GbwapsLayout, ContentBlocks, ProblemSolutionCard },
  data() {
    return {
      pageIntro:
        'Fix GB WhatsApp crashes, login loops, verification codes, install errors, storage issues, and messages that will not send.',
      breadcrumb: [{ name: 'Home', to: '/' }, { name: 'Troubleshooting' }],
      sections: TROUBLESHOOTING_SECTIONS,
    };
  },
};
</script>
